import { Claims, toV2Claims } from "@core-services/data-types"
import CryptoJS from "crypto-js"

interface JwtV1Options {
  authSecret: string
  channelGroupId?: string
  channelId?: string
  startsAt?: Date
  expiresAt?: Date
  ingestPermission?: boolean
}

export const signJwtV1 = (options: JwtV1Options) => {
  const { authSecret, channelId, channelGroupId, startsAt, expiresAt, ingestPermission } = options
  const exp = expiresAt ? Math.round(expiresAt.getTime() / 1000) : undefined
  const nbf = startsAt ? Math.round(startsAt.getTime() / 1000) : undefined
  const payload = {
    channelId,
    channelGroupId,
    exp,
    nbf,
    ingestPermission,
  }

  return sign(authSecret, payload)
}

interface JwtOptions extends Claims {
  authSecret: string
  startsAt?: Date
  expiresAt?: Date
}

export const signJwtV2 = (options: JwtOptions) => {
  const { authSecret, startsAt, expiresAt, ...claims } = options
  const exp = expiresAt ? Math.round(expiresAt.getTime() / 1000) : undefined
  const nbf = startsAt ? Math.round(startsAt.getTime() / 1000) : undefined

  const payload = {
    ...toV2Claims(claims),
    exp,
    nbf,
  }
  return sign(authSecret, payload)
}

const sign = (authSecret: string, payload: unknown) => {
  const header = {
    alg: "HS256",
    typ: "JWT",
  }
  const base64urlencoded = {
    fromString: (s: string) =>
      CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(s))
        .replace(/=/g, "")
        .replace(/\+/g, "-")
        .replace(/\//g, "_"),
    fromBase64: (s: string) => s.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_"),
  }
  const encodedHeader = base64urlencoded.fromString(JSON.stringify(header))
  const encodedPayload = base64urlencoded.fromString(JSON.stringify(payload))
  const signature = base64urlencoded.fromBase64(
    CryptoJS.HmacSHA256(`${encodedHeader}.${encodedPayload}`, authSecret).toString(CryptoJS.enc.Base64)
  )
  return `${encodedHeader}.${encodedPayload}.${signature}`
}

export const defaultJwtExpiry = () => new Date(Date.now() + 1000 * 60 * 60 * 24)
